module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3n4n8r-2528edfe37fa3222a8645b1facfedeed.svg";